import apiClient from '../appConfig/interceptor';
import { endpoints } from '../utils/constants';

export const getEntraConfig = (domainName: string) => apiClient.get(`${endpoints.pathPrefix}entra-config?domainName=${domainName}`);